<div class="h-full">
    <img class="w-0 h-0" #viewer [src]="imageSrc" alt="Slab"/>
</div>